<template lang="pug">
section.territorio
    BaseHeader#cadastrar-territorio(
        :titulo='$t("mensagens.territorio.labels.territorio")',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.territorio.cadastrarTerritorio")',
        :exibeBotao='true',
        @btnHeaderClicado='cadastrarTerritorio'
    )

    .view-container-base-header
        .d-flex
            .lista-territorios__barra-pesquisa
                i.el-icon-search
                input.lista-territorios__barra-pesquisa__input(
                    v-model='search',
                    type='text',
                    :placeholder='$t("mensagens.territorio.procurePeloTerritorio")',
                    autocomplete='off',
                    @keyup.enter='onChangeSearchInput'
                )

            el-dropdown.action-button(trigger='click', :disabled='true')
                el-button.btn-exportar-relatorio(
                    icon='el-icon-download',
                    type='primary',
                    v-if='permissaoAmbiente(ambientes.BRASIL)'
                ) &nbsp;&nbsp;&nbsp; {{ $t('mensagens.exportacao.exportar') }}
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item(
                        icon='el-icon-download',
                        @click.native='exportarRelatorio(true)'
                    ) {{ $t('mensagens.exportacao.simples') }}
                    el-dropdown-item(
                        icon='el-icon-download',
                        @click.native='exportarRelatorio(false)'
                    ) {{ $t('mensagens.exportacao.completa') }}
        .table
            el-table.table-territorios(
                height='100%',
                v-if='territorios.length > 0',
                :data='territorios',
                @sort-change='sortChangeRequest',
                style='width: 100%'
            )
                el-table-column(type='expand')
                    template(slot-scope='props')
                        el-descriptions.descricao-item-tabela(:size='"mini"')
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.labels.pessoasProdutores")',
                                v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.representantes && props.row.representantes.length > 1'
                            )
                                .representantes(
                                    v-for='representante in props.row.representantes',
                                    :key='representante.id'
                                )
                                    p {{ representante.nomeRazaoSocial }} {{ representante.cpfCnpj ? `(${representante.cpfCnpj})` : '' }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.representantes && props.row.representantes.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiPessoasAdicionais")'
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.representantes && props.row.representantes.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiPessoas")'
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.comercializacoes.length'
                        )
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.comercializacoes")'
                            )
                                ul.comercializacoes-infor-lista
                                    li.comercializacoes-infor(
                                        v-for='(comercializacao, index) in props.row.comercializacoes',
                                        :key='index'
                                    )
                                        span.lista-comercializacao {{ comercializacao.produtoNome }} - {{ $t('mensagens.territorio.comercializacao.quantidade') }} {{ comercializacao.quantidade }} {{ comercializacao.unidadeMedidaSimbolo ? `(${comercializacao.unidadeMedidaSimbolo})` : '' }}
                                        span.lista-comercializacao(
                                            v-if='comercializacao.safraAno'
                                        ) - {{ $t('mensagens.territorio.comercializacao.safra') }}: {{ comercializacao.safraAno }}
                                        span.lista-comercializacao(
                                            v-if='comercializacao.numeroContrato'
                                        ) - {{ $t('mensagens.territorio.comercializacao.numeroContrato') }}: {{ comercializacao.numeroContrato }}
                                        span.lista-comercializacao(
                                            v-if='comercializacao.fornecedor'
                                        ) - {{ $t('mensagens.territorio.comercializacao.fornecedor') }}: {{ comercializacao.fornecedor }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.certificacoes.length'
                        )
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.certificacoes")'
                            )
                                ul.certificacoes-infor-lista
                                    li.certificacoes-infor(
                                        v-for='(certificacao, index) in props.row.certificacoes',
                                        :key='index'
                                    ) {{ certificacao.nome }}

                        el-descriptions.descricao-item-tabela(:size='"mini"')
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.labels.car") + ":"',
                                v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length > 1'
                            )
                                .car-list-row
                                    .cars(
                                        v-for='car in props.row.cars',
                                        :key='car.codigo'
                                    )
                                        p {{ car.codigo }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionais")'
                            )
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionaisPY")'
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionais")'
                            )
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionaisPY")'
                            )

                el-table-column(
                    prop='nome',
                    :label='isAlvorada ? "Fazenda" : $t("mensagens.territorio.labels.territorio")',
                    min-width='200px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome }}

                el-table-column(
                    prop='representante',
                    :label='$t("mensagens.territorio.labels.pessoasDocumento")',
                    min-width='200',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        .representante(
                            v-if='scope.row.representantes && scope.row.representantes.length > 0'
                        )
                            p {{ scope.row.representantes[0].nomeRazaoSocial }}
                                span ({{ formatCpfCnpj(scope.row.documentoDecrypt[0]) }})
                                el-tag.ml-2(
                                    v-if='scope.row.representantes.length > 1',
                                    size='mini'
                                )
                                    | {{ scope.row.representantes.length - 1 }}
                        .representante(v-else)
                            p -

                el-table-column(
                    prop='municipio',
                    :label='$t("mensagens.territorio.labels.localidade")',
                    min-width='200px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p {{ scope.row.localidadeNome }}

                el-table-column(
                    :formatter='formatAreaHaTableColumn',
                    prop='areaHa',
                    :label='$t("mensagens.territorio.labels.areaHa")',
                    min-width='150px',
                    sortable='custom'
                )

                el-table-column(
                    v-if='!permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='codigo',
                    :label='$t("mensagens.territorio.labels.car")',
                    min-width='300px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        .car(
                            v-if='scope.row.cars && scope.row.cars.length > 0'
                        )
                            p.car-hiden-row {{ scope.row.cars[0].codigo }}
                            el-tag.ml-2(
                                v-if='scope.row.cars.length > 1',
                                size='mini'
                            )
                                | {{ scope.row.cars.length - 1 }}
                        .car(v-else)
                            p -

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='departamento',
                    :label='$t("mensagens.territorio.labels.departamento")',
                    min-width='140px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(v-if='scope.row.departamentoNome') {{ scope.row.departamentoNome }}
                        p(v-else) -

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='distrito',
                    :label='$t("mensagens.territorio.labels.distrito")',
                    min-width='120px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(v-if='scope.row.distritoNome') {{ scope.row.distritoNome }}
                        p(v-else) -

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='padron',
                    :label='$t("mensagens.territorio.labels.padron")',
                    min-width='100px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(
                            v-if='scope.row.padron !== null && scope.row.padron !== "null"'
                        ) {{ scope.row.padron }}
                        p(v-else) -

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='finca',
                    :label='$t("mensagens.territorio.labels.finca")',
                    min-width='100px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(
                            v-if='scope.row.finca !== null && scope.row.finca !== "null"'
                        ) {{ scope.row.finca }}
                        p(v-else) -

                el-table-column(
                    prop='idCliente',
                    :label='isAlvorada ? "BP Cliente" : $t("mensagens.territorio.labels.idCliente")',
                    min-width='150px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(v-if='scope.row.idCliente') {{ scope.row.idCliente }}
                        p(v-else) -

                el-table-column(
                    prop='dataCadastroFormatada',
                    :label='$t("mensagens.territorio.labels.dataCadastro")',
                    min-width='170px',
                    sortable='custom'
                )

                el-table-column(
                    :label='$t("mensagens.comuns.acoes")',
                    width='140px',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(
                            @click.native='setAtivo(scope.row)',
                            trigger='click'
                        )
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='goToTerritorioDashboard(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.visualizar') }}

                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='handleClickUpdate(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.editar') }}

                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='handleClickDelete(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.remover') }}

                                el-dropdown-item(
                                    v-if='scope.row && usuarioLogado.monitoramentoAccess && usuarioLogado.monitoramentoEnviar && scope.row.internacional === false',
                                    icon='el-icon-map-location',
                                    @click.native='handleClickSendToMonitormaneto(scope.row)'
                                ) {{ verificaMonitoramento }}

                                el-dropdown-item(
                                    v-if='scope.row.internacional === false && !permissaoAmbiente(ambientes.PARAGUAY)',
                                    icon='flow flow-environment',
                                    @click.native='goToDiagnosticoSocioambiental(scope.row)'
                                ) {{ $t('mensagens.diagnosticoSocioambiental.titulo') }}

                                el-dropdown-item(
                                    v-if='!usuarioLogado.operacaoCadastrante',
                                    icon='el-icon-download',
                                    @click.native='baixarKMLTerritorio(scope.row)'
                                ) {{ $t('mensagens.territorio.baixarPoligono') }}

                template(slot='empty')
                    el-empty(
                        :description='$t("mensagens.territorio.voceNaoPossuiTerritoriosCadastrados")'
                    )

            .tabela-rodape
                .tabela-rodape--esquerda
                    p {{ totalTerritorios <= 1 ? totalTerritorios + $t('mensagens.territorio.territorio') : totalTerritorios + $t('mensagens.territorio.territorios') }}

                .tabela-rodape--pagination
                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalTerritorios',
                        @current-change='fetchTerritorios'
                    )

    #modal-delete-territorio-are-you-sure.row(v-if='deleteTerritorioModal')
        el-dialog(:visible.sync='deleteTerritorioModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(style='text-align: left') {{ $t('mensagens.territorio.removerTerritorio') }}
            .column.d-flex.justify-content-center.align-items-center.flex-column
                p.mb-5.texto-modal(v-if='statusMonitoramento === "ATIVO"')
                    | {{ $t('mensagens.territorio.naoFoiPossivelRemoverTerritorioEmMonitoramento') }}

                p.mb16.texto-modal(
                    v-else-if='statusMonitoramento === "CANCELADO"'
                )
                    b.mb-2 Atenção!
                    br
                    | {{ $t('mensagens.territorio.territorioPossuiMonitoramentosCancelados') }}

                p.mb16.texto-modal(v-else)
                    | {{ $t('mensagens.territorio.desejaRemoverTerritorio') }}

                .buttons.mb16(v-show='statusMonitoramento !== "ATIVO"')
                    el-button(
                        size='mini',
                        @click='handleCloseModalDeleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.cancelar') }}
                    el-button(
                        type='primary',
                        size='mini',
                        @click='deleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.remover') }}

    SendOrEditMonitoramento(
        v-if='showMonitoramentoModal',
        :showMonitoramentoModal='showMonitoramentoModal',
        :selectedTerritorioNome='selectedTerritorio.nome',
        :selectedTerritorio='territorioParaMonitoramento',
        actionType='send'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';
import SendOrEditMonitoramento from '@/components/areamonitorada/SendOrEditMonitoramento';
import { required } from 'vuelidate/lib/validators';
import territorioService from '@/services/TerritorioService';
import MonitoramentoService from '@/services/MonitoramentoService';
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import { mapActions, mapGetters, mapState } from 'vuex';
import UtilsService from '@/services/UtilsService';
import { isEmpty } from 'lodash';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import EventBus from '@/utils/eventBus';

export default {
    name: 'index',
    components: {
        BaseHeader,
        EmptyResult,
        SendOrEditMonitoramento
    },
    data() {
        return {
            visible: false,
            territorios: [],
            totalTerritorios: 0,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 20
            },
            isAdding: false,
            territorio: {
                nomeTerritorio: null,
                nomeProdutorCpfCnpj: null,
                cityState: null,
                area: null
            },
            addTerritorioSuccess: false,
            search: null,
            deleteTerritorioModal: false,
            selectedTerritorio: {},
            selectedAction: null,
            territorioParaMonitoramento: {
                idTerritorio: null,
                cultura: null,
                dataPlantio: null,
                areaDoPlantio: null,
                idSafra: null,
                produtividade: null
            },
            statusMonitoramento: '',
            order: null,
            nomeColumn: null,
            verificaMonitoramento: false,
            ambientes: AmbientesEmpresas
        };
    },
    validations: {
        territorio: {
            nomeTerritorio: {
                required
            }
        },
        territorioParaMonitoramento: {
            idSafra: { required }
        }
    },

    created() {
        this.fetchTerritorios();
        this.resetTerritorio();
        this.clearTerritoryTableData();
    },
    filters: {
        formatarAreaDuasCasas: function (value) {
            if (!value) return '';
            const valueString = value.toString();
            return (
                Math.round(Number(valueString.replace(',', '.')) * 100) / 100
            ).toFixed(2);
        }
    },

    computed: {
        ...mapGetters([
            'showMonitoramentoModal',
            'territorioData',
            'usuarioLogado',
            'isAlvorada'
        ]),
        ...mapState(['usuarioLogado'])
    },

    methods: {
        ...mapActions([
            'setTerritorio',
            'clearTerritorio',
            'clearTerritoryTableData',
            'changeShowMonitoramentoModal'
        ]),

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        async exportarRelatorio(simplificado) {
            EventBus.$emit('emit-componente-carregando', {
                mostrarLoading: true,
                lockMessage: this.$t(
                    'mensagens.sistema.preparandoDadosParaDownload'
                )
            });
            territorioService.exportarTerritorios(simplificado);

            await connect();
            if (this.usuarioLogado) {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/territorios/baixar-territorios`,
                    response => {
                        if (response) {
                            response = JSON.parse(response);
                            const base64Data = response.fileData;
                            const byteCharacters = atob(base64Data);
                            const byteArray = new Uint8Array(
                                byteCharacters.length
                            );
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteArray[i] = byteCharacters.charCodeAt(i);
                            }
                            const fileBlob = new Blob([byteArray], {
                                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            });
                            const fileLink = document.createElement('a');
                            const fileURL =
                                window.URL.createObjectURL(fileBlob);
                            fileLink.href = fileURL;
                            const filename = response.filename;
                            fileLink.setAttribute('download', filename);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            document.body.removeChild(fileLink);

                            EventBus.$emit('emit-componente-carregando', {
                                mostrarLoading: false,
                                lockMessage: this.$t(
                                    'mensagens.sistema.preparandoDadosParaDownload'
                                )
                            });
                            disconnect();
                        }
                    }
                );
            } else {
                this.$notify.error({
                    message: 'Usuário deslogado!'
                });
            }
        },

        resetTerritorio() {
            this.$v.$reset();
            this.territorio = {};
        },

        async setAtivo(value) {
            if (this.usuarioLogado.monitoramentoAccess) {
                const response = await MonitoramentoService.verificarTerritorio(
                    value.id
                );
                const data = await response.data;
                if (!isEmpty(data)) {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.atualizarMonitoramento'
                    );
                } else {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.enviarParaMonitoramento'
                    );
                }
            }
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.search = this.search || '';

            if (validators.validarCpf(this.search)) {
                filtro.search = formatters.cpfCnpjFormatToNumeral(this.search);
            }

            filtro.order = '&sort=nome,asc';

            if (this.order && this.nomeColumn) {
                const nomesColunas = {
                    nome: 'nome_territorio',
                    representante: 'nome_representante',
                    municipio: 'nome_cidade',
                    areaHa: 'territorio_area',
                    dataCadastroFormatada: 'territorio_data_cadastro',
                    idCliente: 'territorio_id_cliente'
                };
                const sort = nomesColunas[this.nomeColumn];
                filtro.order = `&sort=${sort},${this.order}`;
            }
            return filtro;
        },

        async fetchTerritorios() {
            let filtro = this.getFiltros();
            const { data } = await territorioService.findAll(filtro);
            this.totalTerritorios = data.totalElements;
            this.territorios = data.content;
        },

        cadastrarTerritorio() {
            this.territorioData.value = 'add';
            this.$router.push({ name: 'CadastrarEditarTerritorio' });
        },

        goToTerritorioDashboard({ id }) {
            this.$router.push({
                name: 'VisualizarTerritorio',
                params: { idTerritorio: id }
            });
        },

        handleClickUpdate(value) {
            territorioService.findById(value.id).then(response => {
                if (response.status === 200) {
                    const result = response.data;
                    result.value = 'edit';
                    this.territorio = result;
                    this.setTerritorio(result);

                    this.$router.push({
                        name: 'CadastrarEditarTerritorio',
                        params: { idTerritorio: value.id }
                    });
                } else {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.erroEditarTerritorio'
                        )
                    });
                }
            });
        },

        deleteTerritorio() {
            territorioService
                .delete(this.selectedTerritorio.id)
                .then(response => {
                    if (response.status === 200) {
                        this.deleteTerritorioModal = false;
                        this.fetchTerritorios();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.removidoComSucesso'
                            )
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensgens.territorio.erroAoRemoverTerritorio'
                            )
                        });
                    }
                });
        },

        async handleClickDelete({ id }) {
            try {
                const { data } = await territorioService.getStatusMonitoramento(
                    id
                );

                this.statusMonitoramento = data;
                this.selectedTerritorio.id = id;
                this.deleteTerritorioModal = true;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoVerificarStatusMonitoramentos'
                    )
                });
            }
        },

        handleCloseModalDeleteTerritorio() {
            this.deleteTerritorioModal = false;
        },

        onChangeSearchInput() {
            this.paginacao.paginaAtual = 1;
            this.fetchTerritorios();
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },

        handleClickSendToMonitormaneto(value) {
            this.selectedTerritorio = value;
            this.territorioParaMonitoramento.idTerritorio =
                this.selectedTerritorio.id;
            this.changeShowMonitoramentoModal();
        },

        sendToMonitoramento() {
            this.$v.territorioParaMonitoramento.$touch();
            if (this.$v.territorioParaMonitoramento.$invalid) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.preenchaCampoObrigatorio'
                    )
                });
            } else {
                MonitoramentoService.envioAreaMonitoramento(
                    this.territorioParaMonitoramento
                )
                    .then(response => {
                        if (response.status === 200) {
                            this.$notify.success({
                                message: this.$t(
                                    'mensagens.territorio.enviadoMonitoramentoComSucesso'
                                )
                            });

                            this.$router.push({ name: 'Monitoramento' });
                        } else {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.territorio.erroAoEnviarTerritorioMonitoramento'
                                )
                            });
                        }
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoEnviarTerritorioMonitoramento'
                            )
                        });
                    });
            }
        },

        utf8Decode(municipio) {
            return formatters.utf8Decode(municipio);
        },

        goToDiagnosticoSocioambiental({ id }) {
            this.$router.push({
                name: 'TerritorioSocioambiental',
                params: { idTerritorio: id }
            });
        },

        sortChangeRequest(column) {
            this.order = null;

            if (column.order === 'ascending') {
                this.order = 'asc';
            } else if (column.order === 'descending') {
                this.order = 'desc';
            }
            this.nomeColumn = column.prop;
            this.fetchTerritorios();
        },

        baixarKMLTerritorio({ id }) {
            territorioService.findById(id).then(({ data }) => {
                UtilsService.baixarKMLdeGeometria(data.geometria);
            });
        }
    }
};
</script>

<style lang="scss">
.territorio {
    height: 100%;
    width: 100%;
    overflow-y: auto;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .lista-territorios__barra-pesquisa {
        margin-right: 20px;
        width: 95%;
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);
        background-color: var(--white);

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-territorios__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .btn-exportar-relatorio {
        width: 200px;
        height: 46px;
    }

    .required-text {
        color: var(--danger);
    }

    #end-add-territorio-button {
        p {
            cursor: pointer;
        }
    }

    .el-table {
        border-radius: 5px 5px 0 0 !important;

        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .table-territorios {
        height: 100%;
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);
    }

    .table {
        height: calc(100vh - 312px);

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 0 0 5px 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 5px 20px;
        color: var(--text-disabled);
        font-size: 14px;
        word-break: break-all;
    }

    .buttons {
        width: 100%;
        gap: 16px;
        display: flex;
        justify-content: space-between;
    }

    .vw-100 {
        width: 100%;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }
}

.example-showcase .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
}

#modal-delete-territorio-are-you-sure {
    text-align: center;
}

#modal-diagnostico-socioambiental {
    text-align: center;

    word-break: keep-all !important;
}

.mb16 {
    margin-bottom: 16px;
}

.justify-content-between.mb-3 {
    display: flex;
    margin-top: 25px;
}

ul.certificacoes-infor-lista {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    flex-direction: row;
}

.certificacoes-infor {
    margin-right: 29px;
}

ul.comercializacoes-infor-lista {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    flex-direction: column;
    padding-left: 14px;
    gap: 14px;
}

li.comercializacoes-infor {
    list-style: none;
}

.texto-modal {
    word-break: break-word !important;
}

.lista-comercializacao {
    padding-right: 5px;
    display: inline-flex;
}
</style>
